import React from "react";
import "./card-rates.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useSettingCarousel from "../../../hooks/carousel";
import CardRatesDescription from "../../atoms/card-rates-description/card-rates-description";
import CardRatesEspecial from "../../atoms/card-rates-description-especial/card-rates-especial";
interface ShareCardInterface {
  login: any;
  datas: any;
  gigyaAccount: any;
  onClose: any;
  setBanderaLog: any;
}
const CardPay = (props: ShareCardInterface) => {
  const { datas, login, gigyaAccount, onClose, setBanderaLog } = props;
  const component = (dots) => {
    return (
      <div style={{ bottom: "-40px" }}>
        <ul>{dots}</ul>
      </div>
    );
  };
  const useCarousel = useSettingCarousel(component);
  return (
    <div>
      <div className="m-share-modal__container__cardbody hide-on-mobile">
        {datas[0].referenciaPlantillaContenido.map((value, key) => {
          return (
            <div key={"desk" + key}>
              {value.imagenPrincipal ? (
                <>
                  <CardRatesDescription
                    datas={value}
                    gigyaAccount={gigyaAccount}
                    login={login}
                    onClose={onClose}
                    setBanderaLog={setBanderaLog}
                  />
                </>
              ) : (
                <>
                  <CardRatesEspecial
                    datas={value}
                    gigyaAccount={gigyaAccount}
                    login={login}
                    onClose={onClose}
                    setBanderaLog={setBanderaLog}
                  />
                </>
              )}
            </div>
          );
        })}
      </div>
      <div className="m-share-modal__container__mobile show-on-mobile">
        <div className="m-share-modal__container__mobile__dots">
          <Slider {...useCarousel}>
            <div>
              <CardRatesEspecial
                datas={
                  datas[0].referenciaPlantillaContenido[
                    datas[0].referenciaPlantillaContenido.length - 1
                  ]
                }
                gigyaAccount={gigyaAccount}
                login={login}
                onClose={onClose}
                setBanderaLog={setBanderaLog}
              />
            </div>
            {datas[0].referenciaPlantillaContenido.map((value, key) => {
              return value.imagenPrincipal ? (
                <div key={"mobile" + key}>
                  <CardRatesDescription
                    datas={value}
                    gigyaAccount={gigyaAccount}
                    login={login}
                    onClose={onClose}
                    setBanderaLog={setBanderaLog}
                  />
                </div>
              ) : (
                ""
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};
export default CardPay;
